<template>
  <div class="pa-5">
    <v-card
      class="pa-5 rounded"
      elevation="2"
      :style="{ backgroundColor: defaultBackgroundColor }"
    >
      <!-- Header -->
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="text-subtitle-1 font-weight-bold">{{ $t("homeCards.overallIsaAllowance") }}</div>
        <div class="text-right">
          <span class="mr-1 caption font-weight-bold">{{ currencyDisplay }}</span>
          <span class="text-h6 font-weight-bold">{{ overallIsaAllowance }}</span>
        </div>
      </div>

      <!-- Voided Amount -->
      <div class="d-flex justify-space-between align-end mt-n4">
        <div class="body-2 grey--text text--darken-1 font-weight-bold">
          {{ $t("homeCards.voidedAmount") }}
        </div>
        <div class="text-right">
          <span class="mr-1 caption grey--text text--darken-1 font-weight-bold">{{ currencyDisplay }}</span>
          <span class="text-h6 font-weight-bold grey--text text--darken-1">{{ voidedAmount }}</span>
        </div>
      </div>

      <div class="my-4"></div>

      <!-- Progress Bar -->
      <div class="progress-bar mb-4">
        <v-progress-linear
          :value="usedPercentage"
          height="21"
          :color="primaryColor"
          :class="['custom-progress', { 'isa-zero': isCashIsaValuesZero }]"
        />
      </div>

      <!-- Legend -->
      <div class="d-flex justify-space-between align-center flex-wrap" style="gap: 16px;">
        <!-- Used Allowance -->
        <div class="d-flex align-center" style="gap: 8px;">
          <span class="circle used"></span>
          <span class="text-subtitle-1">{{ $t("homeCards.isaAllowanceUsed") }}</span>
          <span class="font-weight-bold">
            <span class="mr-1 caption font-weight-bold">{{ currencyDisplay }}</span>
            <span class="text-subtitle-1 font-weight-bold">{{ overallIsaUsed }}</span>
          </span>
        </div>

        <!-- Remaining Allowance -->
        <div class="d-flex align-center" style="gap: 8px;">
          <span class="circle remaining"></span>
          <span class="text-subtitle-1">{{ $t("homeCards.isaAllowanceRemaining") }}</span>
          <span class="font-weight-bold text-no-wrap">
            <span class="mr-1 caption font-weight-bold">{{ currencyDisplay }}</span>
            <span class="text-subtitle-1 font-weight-bold">{{ overallIsaRemaining }}</span>
          </span>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import commonService from '@/service/commonService.js'

export default {
  name: 'OverallSubscriptionIsa',
  data () {
    return {
      usedPercentage: 0,
      overallIsaAllowance: '',
      overallIsaUsed: '',
      overallIsaRemaining: '',
      voidedAmount: '',
      customerId: '',
      currencyDisplay: ''
    }
  },
  computed: {
    isCashIsaValuesZero () {
      return (
        this.convertToNumeric(this.overallIsaAllowance) === 0 &&
        this.convertToNumeric(this.overallIsaRemaining) === 0 &&
        this.convertToNumeric(this.overallIsaUsed) === 0
      )
    }
  },
  created () {
    this.customerId = JSON.parse(sessionStorage.getItem('username'))
    this.getOverallSubScription(this.customerId)
  },
  methods: {
    async getOverallSubScription (customerId) {
      const response = await commonService.getOverallSubscrptionCashIsa(customerId)
      if (response && response.customerId) {
        const total = response.totalSubscriptionAmount.amount
        const used = response.totalSubscriptionamtUsed.amount
        const remaining = (used / total) * 100
        this.usedPercentage = Number(remaining.toFixed(2)).toLocaleString()

        this.currencyDisplay = response.totalSubscriptionAmount.currency
        this.overallIsaAllowance = Number(response.totalSubscriptionAmount.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.overallIsaUsed = Number(response.totalSubscriptionamtUsed.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.overallIsaRemaining = Number(response.totalSubscriptionamtRemain.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.voidedAmount = Number(response.totalVoidedAmount.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    },
    convertToNumeric (val) {
      if (!val) return 0
      const number = parseFloat(val.replace(/[^0-9.]/g, ''))
      return isNaN(number) ? 0 : number
    }
  }
}
</script>

<style lang="scss" scoped>
.circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.circle.remaining {
  background-color: #CCB9F5;
}

.circle.used {
  background-color: #694ed6;
}

.progress-bar {
  margin-bottom: 20px;
  border-radius: 18px;
  overflow: hidden;
}

.custom-progress ::v-deep(.v-progress-linear__background) {
  border-radius: 0 !important;
}
.custom-progress ::v-deep(.v-progress-linear__bar) {
  border-radius: 18px !important;
  transition: all 0.3s ease;
}

.custom-progress ::v-deep(.v-progress-linear__background) {
  background-color: #CCB9F5;
}

.custom-progress.isa-zero ::v-deep(.v-progress-linear__background) {
  background-color: #9e9e9e !important;
}
</style>
